export default __webpack_public_path__ + "static/media/q_right_bg.b29dcaee.png";